import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import Layout from 'components/layout/Layout'
import { DEFAULT_NAMESPACES } from 'constants/i18n'
import type { SeoProps } from 'components/seo/types'
import { useTranslation } from 'next-i18next/pages'
import { cmsLib } from 'lib/index'
import { faqCategoriesSlugs } from 'constants/faq-categories'
import { FAQCategories } from 'features/faq-page/types'
import { BoltXPlentyProps } from 'features/bolt-x-plenty/types'
import BoltXPlenty from 'features/bolt-x-plenty/BoltXPlenty'

const BoltXPlentyPage = (props: BoltXPlentyProps) => {
  const { t } = useTranslation('boltXPlenty')

  const SEO: SeoProps = {
    description: t('seo.description'),
    title: t('seo.title')
  }

  return (
    <Layout seo={SEO}>
      <BoltXPlenty {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  const faqCategories = (await cmsLib.getFaqCategories(faqCategoriesSlugs[FAQCategories.BOLT_X_PLENTY], locale)) || []

  return {
    props: {
      faqCategories,
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, 'boltXPlenty'], i18nConfig))
    }
  }
}

export default BoltXPlentyPage
